import React from 'react';
import { withRouter } from 'react-router-dom';
import GridOrc from './GridOrc.jsx';

class Orcamento extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [
                "Ano",
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro",
                "Total",
                "Comentário" ],
            orcamentos: [],
            centroId: 0,
            centro: "",
            id: 0,
            codConta: "",
            conta: "",
            tipoConta: "",
            tipoContaNome: "",
            naturezaConta: "",
            cultura: ""
        };

        this.voltar = this.voltar.bind(this);
        this.cadastrar = this.cadastrar.bind(this);

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.id,
                data: [
                    this.state.codConta,
                    this.state.conta,
                    this.state.tipoContaNome,
                    this.state.naturezaConta,
                    this.state.cultura
                ]
            }
        };

        this.props.history.push({
            pathname: "/visualizarconta",
            state: obj
        });

    }

    cadastrar() {

        let obj = {
            id: this.state.id,
            codConta: this.state.codConta,
            conta: this.state.conta,
            tipoConta: this.state.tipoContaNome,
            tipoContaId: this.state.tipoConta,
            naturezaConta: this.state.naturezaConta,
            cultura: this.state.cultura,
            centroId: this.state.centroId,
            centro: this.state.centro
        };

        this.props.history.push({
            pathname: "/cadastrarorcamento",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleContas === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/contas";
        }

        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;
        let id = this.props.location.state.id;
        let codConta = this.props.location.state.codConta;
        let conta = this.props.location.state.conta;
        let tipoContaNome = this.props.location.state.tipoConta;
        let tipoConta = this.props.location.state.tipoContaId;
        let naturezaConta = this.props.location.state.naturezaConta;
        let cultura = this.props.location.state.cultura;

        this.setState({ centroId: centroId });
        this.setState({ centro: centro });
        this.setState({ id: id });
        this.setState({ codConta: codConta });
        this.setState({ conta: conta });
        this.setState({ tipoConta: tipoConta });
        this.setState({ tipoContaNome: tipoContaNome });
        this.setState({ naturezaConta: naturezaConta });
        this.setState({ cultura: cultura });

        fetch("/api/orcamento/grid/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ orcamentos: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="orcamento-title">Orçamento</h1><br />
                <br />
                <p id="orcamento-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <p id="orcamento-conta">
                    <b>Conta: </b> { this.state.conta }
                </p><br />
                <GridOrc key={ this.state.orcamentos }
                    header={ this.state.gridHeader }
                    data={ this.state.orcamentos }
                    pageSize={ 10 }
                    gridWidth={ "1350px" } />
                <br />
                <button id="orcamento-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                { localStorage.roleContas === "escrever" &&
                    <button id="orcamento-cadastrar-btn" onClick={ this.cadastrar }>
                        Cadastrar Novo Orçamento
                    </button> }
                <br /><br />
            </div>
        );
    }

}

export default withRouter(Orcamento);

